// extracted by mini-css-extract-plugin
export default {"price":"card_price__tgdLw","card":"card_card__B1Hm1","name":"card_name__UKaxt","relative":"card_relative__ym1GG","image":"card_image__F2DR0"};